import { render, staticRenderFns } from "./PostGridItem.vue?vue&type=template&id=4b1eac94&"
import script from "./PostGridItem.vue?vue&type=script&lang=js&"
export * from "./PostGridItem.vue?vue&type=script&lang=js&"
import style0 from "./PostGridItem.vue?vue&type=style&index=0&id=4b1eac94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports